import { styling } from "styling";
import { max } from "moment";

export const STATES = {
  FULL: 1,
  HALF: 2,
  EMPTY: 3,
};

export const COLORS = {
  [STATES.FULL]: styling.bordeauxRed,
  [STATES.HALF]: styling.orange,
  [STATES.EMPTY]: styling.green,
};

export const DISABLED_COLORS = {
  [STATES.FULL]: styling.bordeauxRedDisabled,
  [STATES.HALF]: styling.orangeDisabled,
  [STATES.EMPTY]: styling.greenDisabled,
};

// ==============
// Determine the color of a timeBlock.
// ==============
export function getState(duration, durationMin, occupiedMin, maxGapMin) {
  if (maxGapMin < 50) {
    return STATES.HALF;
  }
  if (duration === 0 || duration <= maxGapMin) {
    return STATES.EMPTY;
  }
  if (duration <= durationMin - occupiedMin) {
    return STATES.HALF;
  }
  return STATES.FULL;
}

export function getColorDefault(
  durationMin,
  occupiedMin,
  maxGapMin,
  disabled = false,
) {
  // Get the state, empty by default.
  let state = STATES.EMPTY;
  // If the max gap is less than 50 min, half
  if (maxGapMin < 50) {
    state = STATES.HALF;
  } else if (occupiedMin >= durationMin / 2) {
    // If the timeSlot is halfway occupied, half.
    state = STATES.HALF;
  }

  // Get the color for the state.
  if (disabled) {
    return DISABLED_COLORS[state];
  }
  return COLORS[state];
}

export function getColor(
  duration,
  durationMin,
  occupiedMin,
  maxGapMin,
  disabled = false,
) {
  const state = getState(duration, durationMin, occupiedMin, maxGapMin);
  if (disabled) {
    return DISABLED_COLORS[state];
  }
  return COLORS[state];
}

// ==============
// Alternative to determining the color of a timeBlock.
// this function checks purely if a duration can fit.
// ==============
export function getStateFitting(duration, durationMin, occupiedMin, maxGapMin) {
  if (maxGapMin >= duration) {
    return STATES.EMPTY;
  }
  if (durationMin - occupiedMin >= duration) {
    return STATES.HALF;
  }
  return STATES.FULL;
}

export function getColorFitting(
  duration,
  durationMin,
  occupiedMin,
  maxGapMin,
  disabled = false,
) {
  const state = getStateFitting(duration, durationMin, occupiedMin, maxGapMin);
  if (disabled) {
    return DISABLED_COLORS[state];
  }
  return COLORS[state];
}
